<template>
  <div class="container">
    <div class="mt-5 mb-3 text-center">
      <h3 class="mb-3">Hero Image</h3>
      <BootstrapIcon
        class="add-btn primary"
        icon="plus-circle"
        @click="showModal"
      />
    </div>

    <table class="table table-hover table-striped table-bordered align-middle">
      <caption>
        Hero Images
      </caption>
      <thead>
        <tr>
          <th scope="col">Preview</th>
          <th scope="col">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="image._id" v-for="image in data">
          <AdminHeroImgTable :image="image" />
        </tr>
      </tbody>
    </table>

    <ModalHeroImage v-if="displayModal" @close-modal-event="hideModal" />
  </div>
</template>
<script>
import axios from "axios";
import AdminHeroImgTable from "./AdminHeroImgTable.vue";
import ModalHeroImage from "./ModalHeroImage.vue";
export default {
  name: "AdminHeroImage",
  components: {
    ModalHeroImage,
    AdminHeroImgTable,
  },
  data() {
    return {
      displayModal: false,
      data: null,
    };
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
  },
  created() {
    axios
      .get(this.$webDomain + "/gardenInit/GardenBasic")
      .then((response) => (this.data = response.data.data[0].topImageList));
  },
};
</script>

<style scoped>
.table {
  max-width: 1000px;
  margin: 1.5rem auto;
}
</style>
